/* Contempo — upholstery configurator (American Leather, Luonto, Jonathan Louis) + AL upgrades */
(function () {
  var PAGE = 24;
    var TYPE_LABEL = { f: 'Fabric', l: 'Leather', m: 'Leather Match', c: 'Your Own Fabric' };
  var FIN_COLOR = { 'Dune': '#cdb99b', 'Ebony': '#2a2421', 'Mink': '#6b5545', 'Oiled Ash': '#d9c9ad', 'Natural Walnut': '#7a5233', 'Brushed Stainless': '#c3c6c9', 'Antique Brass': '#a27d45', 'Burnished Bronze': '#6d4e35', 'Polished Nickel': '#dcdcd8', 'Gloss Black': '#111', 'Gloss Bronze': '#5a4330', 'Polished Aluminum': '#d2d5d8', 'Stainless steel base': '#c3c6c9', 'Brushed Stainless Steel': '#c3c6c9', 'Metal with Natural Walnut Accents': 'linear-gradient(90deg,#7a5233 50%,#9a9a9a 50%)' };

  var SMALL = /^(a|an|and|as|at|but|by|for|from|in|of|on|or|the|to|vs|via|with)$/i;
  function tc(str) {
    return String(str == null ? '' : str).replace(/[A-Za-z][A-Za-z'’]*/g, function (w, i) {
      if (i > 0 && SMALL.test(w)) return w.toLowerCase();
      if (/[A-Z]/.test(w.slice(1))) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    });
  }
  var FEATS = [['pet', 'Pet-Friendly'], ['stain', 'Stain-Resistant'], ['bleach', 'Bleachable'], ['water', 'Water-Repellent'], ['clean', 'Easy-Clean'], ['eco', 'Eco-Friendly']];
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('en-US'); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  // Grade option value -> {t: type, c: code, label}
  function parseGrade(v) {
    var m;
    if ((m = v.match(/^Fabric Grade\s+(\w+)/i))) return { t: 'f', c: m[1], label: 'Grade ' + m[1] };
    if ((m = v.match(/^Leather Grade\s+(\w+)/i))) return { t: 'l', c: m[1], label: 'Grade ' + m[1] };
    if ((m = v.match(/^Grade\s+([A-Z])\b.*Fabric/i))) return { t: 'f', c: m[1], label: 'Grade ' + m[1] };
    if ((m = v.match(/^LM\s?(\d{4})/i))) return { t: 'm', c: m[1], label: 'LM' + m[1] };
    if ((m = v.match(/^L\s?(\d{4})/i))) return { t: 'l', c: m[1], label: 'L' + m[1] };
    if (/^Prescott/i.test(v)) return { t: 'l', c: 'Prescott', label: 'Prescott' };
    if (/^(Top Grain )?Leather$/i.test(v)) return { t: 'l', c: 'Leather', label: 'Leather' };
    return null;
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var form = document.getElementById(root.dataset.form);
    var data = JSON.parse(root.querySelector('.cf-alc__variants').textContent);
    var opts = data.options, variants = data.variants, gi = data.gradeIndex;
    var prefix = root.dataset.prefix || '';
    var $ = function (s) { return root.querySelector(s); };
    var grid = $('.cf-alc__grid'), more = $('.cf-alc__more');
    var pName = $('.cf-alc__p-name'), pSku = $('.cf-alc__p-sku');

    var gradeVals = [];
    var FIXED = gi < 0 ? (root.dataset.fixed || 'Basic') : null;
    if (FIXED) gradeVals.push(FIXED); else variants.forEach(function (v) { if (gradeVals.indexOf(v.o[gi]) < 0) gradeVals.push(v.o[gi]); });
    var G = {};
    gradeVals.forEach(function (g) { G[g] = parseGrade(g) || { t: 'f', c: g, label: g }; });

    var st = { sel: {}, type: 'f', grade: null, color: '', q: '', feats: [], shown: PAGE, sw: null, all: null };

    var holder = root.closest('.product-single__meta, .product-grid__content');
    if (holder) holder.classList.add('cf-alc-on');

    function img(s, w) { return '/cdn/shop/files/' + prefix + s.k + '.' + (s.x || 'jpg') + '?width=' + (w || 240); }
    function swType(t) { return t === 'm' ? 'l' : t; }
    function count(g) {
      if (!st.all) return -1;
      var p = G[g];
      return st.all.filter(function (s) { return s.t === swType(p.t) && s.g === p.c; }).length;
    }
    function find(gradeVal) {
      return variants.filter(function (v) {
        for (var i = 0; i < opts.length; i++) {
          var want = i === gi ? gradeVal : st.sel[i];
          if (want != null && v.o[i] !== want) return false;
        }
        return true;
      })[0];
    }
    function gradesOfType(t) {
      return gradeVals.filter(function (g) { return G[g].t === t && find(g) && count(g) !== 0; });
    }
    function types() { var t = ['f', 'l', 'm'].filter(function (t) { return gradesOfType(t).length; }); if (comOK()) t.push('c'); return t; }
    function comGrade() { return gradeVals.filter(function (g) { return G[g].t === 'f' && G[g].c === 'I' && find(g); })[0] || null; }
    function comYards() { var c = typeof upCtx === 'function' ? upCtx() : null; return c ? c.com : 0; }
    function comOK() { return !!(root.dataset.upg && comGrade() && comYards() > 0); }
    function basePrice() {
      var ps = gradeVals.filter(function (g) { return count(g) !== 0; }).map(find).filter(Boolean).map(function (v) { return v.price; });
      return ps.length ? Math.min.apply(null, ps) : 0;
    }
    function comSw() { return { t: 'c', g: 'I', k: '', n: 'Your Own Fabric (C.O.M.)', sku: 'COM', com: true }; }
    function gradeOfSwatch(s) {
      return gradeVals.filter(function (g) { return G[g].t === st.type && G[g].c === s.g && find(g); })[0] || st.grade;
    }

    function renderOptions() {
      var box = $('.cf-alc__opts'), html = '', n = 0;
      opts.forEach(function (name, i) {
        if (i === gi) return;
        var vals = [];
        variants.forEach(function (v) { if (vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
        if (vals.length < 2) return;
        n++;
        html += '<div class="cf-alc__step"><div class="cf-alc__label"><span class="cf-alc__num">' + n + '</span> Choose ' + esc(tc(name)) + '</div><div class="cf-alc__optvals">' +
          vals.map(function (val) {
            return '<button type="button" class="cf-alc__opt' + (st.sel[i] === val ? ' is-active' : '') + '" data-i="' + i + '" data-v="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('') + '</div></div>';
      });
      box.innerHTML = html;
      var typesHidden = types().length < 2;
      root.querySelectorAll('.cf-alc__num[data-step]').forEach(function (e) {
        if (e.dataset.step === 'type' && typesHidden) return;
        e.textContent = ++n;
      });
    }

    function renderTypes() {
      var ts = types(), box = $('.cf-alc__types');
      if (ts.length && ts.indexOf(st.type) < 0) st.type = ts[0];
      box.style.gridTemplateColumns = 'repeat(' + Math.max(ts.length, 1) + ', 1fr)';
      box.innerHTML = ts.map(function (t) {
        return '<button type="button" class="cf-alc__type' + (t === st.type ? ' is-active' : '') + '" data-type="' + t + '">' + TYPE_LABEL[t] + '</button>';
      }).join('');
      box.closest('.cf-alc__step').hidden = ts.length < 2;
    }

    function renderGrades() {
      $('.cf-alc__grades').closest('.cf-alc__step').hidden = st.type === 'c';
      if (st.type === 'c') return;
      if (FIXED) {
        var hint = $('.cf-alc__grades').closest('.cf-alc__step').querySelector('.cf-alc__hint'); if (hint) hint.textContent = '';
        $('.cf-alc__grades').innerHTML = '<p class="cf-alc__fixednote">This price includes any of our <strong>' + esc(FIXED) + '</strong> fabrics below. Prefer a premium fabric or leather? <a href="/pages/contact-us">Ask us for a quote</a>.</p>';
        return;
      }
      var base = basePrice();
      $('.cf-alc__grades').innerHTML = gradesOfType(st.type).map(function (g) {
        var v = find(g), diff = v.price - base, n = count(g);
        return '<button type="button" class="cf-alc__grade' + (st.grade === g ? ' is-active' : '') + '" data-g="' + esc(g) + '">' +
          '<span class="cf-alc__gname">' + esc(G[g].label) + '</span>' +
          '<span class="cf-alc__gprice">' + money(v.price) + '</span>' +
          '<span class="cf-alc__gdiff">' + (diff > 0 ? '+' + money(diff) : 'Starting Price') + (n > 0 ? ' · ' + n + ' Choices' : '') + '</span></button>';
      }).join('');
    }

    function filtered() {
      if (!st.all) return [];
      var q = st.q.toLowerCase(), allowed = gradesOfType(st.type).map(function (g) { return G[g].c; });
      return st.all.filter(function (s) {
        if (s.t !== swType(st.type)) return false;
        if (allowed.indexOf(s.g) < 0) return false;
        if (st.grade && s.g !== G[st.grade].c) return false;
        if (st.color && s.c.indexOf(st.color) < 0) return false;
        for (var fi = 0; fi < st.feats.length; fi++) if (s.f.indexOf(st.feats[fi]) < 0) return false;
        if (q && s.n.toLowerCase().indexOf(q) < 0) return false;
        return true;
      });
    }

    function renderColors() {
      var set = {}, sel = $('.cf-alc__color');
      (st.all || []).forEach(function (s) { if (s.t === swType(st.type)) s.c.split('/').forEach(function (c) { if (c) set[c] = 1; }); });
      var keys = Object.keys(set).sort();
      sel.hidden = !keys.length;
      sel.innerHTML = '<option value="">All colors</option>' + keys.map(function (c) { return '<option' + (c === st.color ? ' selected' : '') + '>' + esc(c) + '</option>'; }).join('');
    }

    function renderFeats() {
      var box = $('.cf-alc__feats'); if (!box) return;
      var q = (st.all || []).filter(function (s) { return s.t === swType(st.type); });
      var have = FEATS.filter(function (f) { return q.some(function (s) { return s.f.indexOf(f[0]) >= 0; }); });
      st.feats = st.feats.filter(function (k) { return have.some(function (f) { return f[0] === k; }); });
      box.hidden = !have.length;
      box.innerHTML = have.length ? '<span class="cf-alc__featlbl">Filter by Feature:</span>' + have.map(function (f) {
        var on = st.feats.indexOf(f[0]) >= 0;
        return '<button type="button" class="cf-alc__feat' + (on ? ' is-active' : '') + '" data-f="' + f[0] + '" aria-pressed="' + on + '">' + f[1] + '</button>';
      }).join('') : '';
    }
    function renderGrid() {
      var com = $('.cf-alc__com'), isC = st.type === 'c';
      if (com) {
        com.hidden = !isC;
        $('.cf-alc__filters').hidden = isC; grid.hidden = isC; $('.cf-alc__note').hidden = isC;
        if (isC) {
          more.hidden = true; $('.cf-alc__count').textContent = ''; $('.cf-alc__tword').textContent = 'Own Fabric'; var fz = $('.cf-alc__feats'); if (fz) fz.hidden = true;
          var y = comYards();
          com.innerHTML = '<p><strong>Customer’s Own Material (C.O.M.)</strong> — send us your own fabric and American Leather will upholster this piece in it. Priced the same as Fabric Grade I.</p>' +
            '<p class="cf-alc__comyd">You’ll need about <strong>' + y + ' yards</strong> of 54"-wide fabric (plain, no pattern repeat). Patterned fabric may need more — we’ll confirm before ordering.</p>' +
            '<label class="cf-alc__comlbl">Fabric Name, Color &amp; Source <span>(Required)</span><input type="text" class="cf-alc__comin" value="' + esc(st.comDesc || '') + '" placeholder="e.g. Kravet 12345 Linen, 20 yds"></label>' +
            '<p class="cf-alc__comnote">After you order, ship the fabric to our San Jose showroom (405 E. Santa Clara St). We check it and send it to American Leather for approval.</p>';
          return;
        }
      }
      var list = filtered();
      $('.cf-alc__count').textContent = st.all ? '(' + list.length + ')' : '';
      $('.cf-alc__tword').textContent = st.type === 'f' ? 'Fabric' : 'Leather';
      renderFeats();
      if (!st.all) { grid.innerHTML = '<p class="cf-alc__empty">Loading swatches…</p>'; more.hidden = true; return; }
      grid.innerHTML = list.slice(0, st.shown).map(function (s) {
        var on = st.sw && st.sw.k === s.k, g = gradeOfSwatch(s);
        var badge = s.b;
        return '<button type="button" class="cf-alc__sw' + (on ? ' is-active' : '') + '" data-k="' + esc(s.k) + '" title="' + esc(s.n) + '">' +
          '<img loading="lazy" src="' + img(s) + '" alt="' + esc(s.n) + '" width="120" height="120">' +
          '<span class="cf-alc__swname">' + esc(s.n) + '</span>' +
          '<span class="cf-alc__swmeta">' + esc(g && G[g] ? G[g].label : s.g) + (badge ? ' · ' + esc(badge) : '') + '</span></button>';
      }).join('') || '<p class="cf-alc__empty">No matches. Try another color or grade.</p>';
      more.hidden = list.length <= st.shown;
      more.textContent = 'Show ' + Math.min(PAGE, list.length - st.shown) + ' More (' + (list.length - st.shown) + ' Left)';
    }

    function applyVariant() {
      var v = st.grade && find(st.grade);
      if (!v || !form) return;
      var input = form.querySelector('[name="id"]');
      if (input) { input.value = v.id; input.disabled = false; }
      var pb = document.querySelector('block-price[data-section-id="' + root.dataset.section + '"]') || document.querySelector('block-price');
      if (pb) {
        var on = v.compare > v.price;
        pb.querySelectorAll('.price-prefix').forEach(function (e) { e.textContent = ''; });
        var reg = pb.querySelector('.block-price__regular'), sale = pb.querySelector('.block-price__sale');
        if (reg) reg.innerHTML = '<span class="cf-alc__pnow">' + money(v.price) + '</span>';
        if (sale) sale.innerHTML = on ? '<s class="cf-alc__pwas">' + money(v.compare) + '</s> <span class="cf-alc__pnow">' + money(v.price) + '</span> <span class="block-price__save">Save ' + money(v.compare - v.price) + '</span>' : '';
        [pb].concat([].slice.call(pb.querySelectorAll('[data-on-sale]'))).forEach(function (e) {
          if (on) e.setAttribute('data-on-sale', ''); else e.removeAttribute('data-on-sale');
        });
        var stack = pb.querySelector('.block-price__regular') && pb.querySelector('.block-price__regular').parentElement;
        if (stack) { if (on) stack.setAttribute('data-on-sale', ''); else stack.removeAttribute('data-on-sale'); }
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }

    function renderSummary() {
      var s = st.sw, v = st.grade && find(st.grade);
      $('.cf-alc__selimg').innerHTML = s && s.k ? '<img src="' + img(s, 120) + '" alt="">' : '';
      $('.cf-alc__selname').textContent = s ? s.n : (st.grade ? 'Now Pick a ' + (st.type === 'f' ? 'Fabric' : 'Leather') + ' in ' + G[st.grade].label : 'No Upholstery Selected Yet');
      var other = opts.map(function (n, i) { return i === gi ? null : st.sel[i]; }).filter(Boolean).join(' · ');
      $('.cf-alc__selgrade').textContent = s ? [other, st.grade].filter(Boolean).join(' · ') : other;
      $('.cf-alc__selprice').textContent = v ? money(v.price) : 'From ' + money(basePrice());
      pName.value = s ? (s.com ? 'C.O.M. – ' + (st.comDesc || '') + ' (' + comYards() + ' yds needed)' : s.n + ' (' + st.grade + ')') : '';
      pSku.value = s ? s.sku : '';
      pName.disabled = pSku.disabled = !s;
      root.classList.toggle('is-complete', !!s);
    }

    var cache = {};
    function renderDetails() {
      var box = $('.cf-alc__details'), s = st.sw;
      if (!s || s.com) { box.hidden = true; box.innerHTML = ''; return; }
      box.hidden = false;
      var head = '<div class="cf-alc__dimg"><img src="' + img(s, 480) + '" alt="' + esc(s.n) + '"></div>' +
        '<div class="cf-alc__dbody"><div class="cf-alc__dname">' + esc(s.n) + '</div>' +
        '<div class="cf-alc__dgrade">' + esc(st.grade) + (s.b ? ' · ' + esc(s.b) : '') + '</div>';
      var info = s.info ? '<div class="cf-alc__ddesc"><p>' + esc(s.info) + '</p></div>' : '';
      if (!s.h) { box.innerHTML = head + info + '</div>'; return; }
      function draw(p) {
        if (st.sw !== s) return;
        var d = p ? String(p.description || '').replace(/<h\d[^>]*>[\s\S]*?<\/h\d>/gi, '') : '';
        box.innerHTML = head + (d ? '<div class="cf-alc__ddesc">' + d + '</div>' : info) +
          '<div class="cf-alc__dact">' + (p && p.available ? '<button type="button" class="cf-alc__order" data-v="' + p.variants[0].id + '">Order This Free Swatch</button>' : '') +
          '<a href="/products/' + esc(s.h) + '" target="_blank" rel="noopener">View Full Details</a></div></div>';
      }
      if (cache[s.h] !== undefined) return draw(cache[s.h]);
      box.innerHTML = head + '<div class="cf-alc__ddesc cf-alc__loading">Loading details…</div></div>';
      fetch('/products/' + s.h + '.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { cache[s.h] = p; draw(p); }).catch(function () { cache[s.h] = null; draw(null); });
    }

    function render() { renderTypes(); renderOptions(); renderGrades(); renderColors(); renderGrid(); renderSummary(); renderDetails(); if (typeof renderUpg === 'function') renderUpg(); }

    function pickDefaultGrade() {
      if (st.type === 'c') { if (comOK()) { st.grade = comGrade(); st.sw = comSw(); return; } st.type = 'f'; st.sw = null; }
      var list = gradesOfType(st.type);
      if (!list.length) { var ts = types(); if (ts.length) { st.type = ts[0]; list = gradesOfType(st.type); } }
      if (!st.grade || list.indexOf(st.grade) < 0) st.grade = list[0] || null;
      if (st.sw && st.grade && (st.sw.g !== G[st.grade].c || st.sw.t !== swType(st.type))) st.sw = null;
    }

    root.addEventListener('click', function (e) {
      var o = e.target.closest('.cf-alc__order');
      if (o) {
        o.disabled = true; o.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +o.dataset.v, quantity: 1 }] }) })
          .then(function (r) { o.textContent = r.ok ? 'Free Swatch Added to Cart ✓' : 'Could Not Add — Try Again'; if (!r.ok) o.disabled = false; });
        return;
      }
      var t = e.target.closest('.cf-alc__opt, .cf-alc__type, .cf-alc__grade, .cf-alc__sw, .cf-alc__more');
      if (!t) return;
      if (t.classList.contains('cf-alc__opt')) {
        st.sel[+t.dataset.i] = t.dataset.v;
        pickDefaultGrade(); applyVariant(); render();
      } else if (t.classList.contains('cf-alc__type')) {
        if (st.type === t.dataset.type) return;
        st.type = t.dataset.type; st.grade = null; st.sw = null; st.color = ''; st.shown = PAGE;
        if (st.type === 'c') { st.grade = comGrade(); st.sw = comSw(); applyVariant(); render(); return; }
        pickDefaultGrade(); applyVariant(); render();
      } else if (t.classList.contains('cf-alc__grade')) {
        st.grade = t.dataset.g; st.shown = PAGE;
        if (st.sw && st.sw.g !== G[st.grade].c) st.sw = null;
        applyVariant(); render();
      } else if (t.classList.contains('cf-alc__sw')) {
        var s = st.all.filter(function (x) { return x.k === t.dataset.k; })[0];
        st.sw = s; st.grade = gradeOfSwatch(s);
        applyVariant();
        $('.cf-alc__error').hidden = true;
        renderGrades(); renderGrid(); renderSummary(); renderDetails(); renderUpg();
      } else { st.shown += PAGE; renderGrid(); }
    });
    root.addEventListener('input', function (e) { if (e.target.classList.contains('cf-alc__comin')) { st.comDesc = e.target.value; renderSummary(); } });
    $('.cf-alc__search').addEventListener('input', function (e) { st.q = e.target.value; st.shown = PAGE; renderGrid(); });
    $('.cf-alc__color').addEventListener('change', function (e) { st.color = e.target.value; st.shown = PAGE; renderGrid(); });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.cf-alc__feat'); if (!b) return;
      var k = b.dataset.f, i = st.feats.indexOf(k);
      if (i < 0) st.feats.push(k); else st.feats.splice(i, 1);
      st.shown = PAGE; renderGrid();
    });


    /* ---------- Upgrades (American Leather): cushion fill, power, mattress, finishes ---------- */
    var U = { on: !!root.dataset.upg, data: null, ids: null, sel: {}, fill: '', matt: '', leg: '', note: '', added: false };
    var upBox = $('.cf-alc__upg');
    function partsOf(sku) {
      return String(sku || '').split(' + ').map(function (x) {
        var m = x.trim().match(/^(.*?)(?:\s*\((\d+)\))?$/); return [m[1], +(m[2] || 1)];
      });
    }
    function upCtx() {
      var v = st.grade && find(st.grade);
      if (!U.data || !v) return null;
      var set = null, seats = 0, pieces = 0, msize = null, com = 0;
      partsOf(v.sku).forEach(function (p) {
        var r = U.data.sku[p[0]]; if (!r) return;
        if (!set) set = U.data.sets[r[0]];
        seats += r[1] * p[1]; pieces += p[1]; if (!msize && r[2]) msize = r[2]; com += (r[3] || 0) * p[1];
      });
      if (!set) return null;
      return { set: set, seats: Math.max(seats, 1), pieces: Math.max(pieces, 1), msize: msize, com: Math.round(com * 10) / 10 };
    }
    function vtitle(lab, price) { return lab + ' — $' + price; }
    function upItems() {
      var c = upCtx(), out = [];
      if (!c) return out;
      var skirt = null;
      c.set.p.forEach(function (o) {
        var key = o[0], kind = o[1], lab = o[2], price = o[3], ps = o[4], qty = ps ? c.seats : c.pieces;
        var vlab = key === 'Skirted FAB' ? 'Skirted base (fabric)' : key === 'Skirted LTHR' ? 'Skirted base (leather)' : lab;
        var it = { key: key, kind: kind, lab: lab, price: price, qty: qty, ps: ps, vt: vtitle(vlab, price) };
        if (kind === 'leg') return;
        if (kind === 'skirt') { var want = st.type === 'f' ? 'Skirted FAB' : 'Skirted LTHR'; if (key === want || !skirt) skirt = it; return; }
        out.push(it);
      });
      if (skirt) out.push(skirt);
      return out;
    }
    function legItems() {
      var c = upCtx(); if (!c) return [];
      var out = c.set.f.map(function (f) { return { key: 'fin:' + f, lab: f, price: 0, qty: 0 }; });
      var hasLeg = c.set.p.some(function (o) { return o[1] === 'leg'; });
      if (!out.length && hasLeg) out.push({ key: 'fin:Standard', lab: 'Standard finish', price: 0, qty: 0 });
      c.set.p.forEach(function (o) { if (o[1] === 'leg') out.push({ key: o[0], lab: o[2], price: o[3], qty: c.pieces, ps: 0, vt: vtitle(o[0] === 'Metal Base' ? 'Stainless steel base' : 'Natural Walnut legs / base', o[3]) }); });
      return out;
    }
    function mattItems() {
      var c = upCtx(); if (!c || !c.msize || !c.set.m[c.msize]) return [];
      var pr = c.set.m[c.msize], sz = c.msize.toLowerCase().replace(/\b\w/g, function (x) { return x.toUpperCase(); });
      return [{ key: 'gel', lab: 'Cooling Gel mattress', price: pr[0], qty: 1, vt: vtitle('Cooling Gel mattress, ' + sz, pr[0]) },
              { key: 'tp', lab: 'Tempur-Pedic mattress', price: pr[1], qty: 1, vt: vtitle('Tempur-Pedic mattress, ' + sz, pr[1]) }];
    }
    function chosen() {
      var list = [];
      upItems().forEach(function (it) {
        if (it.kind === 'fill' ? U.fill === it.key : U.sel[it.kind === 'skirt' ? 'skirt' : it.key]) list.push(it);
      });
      mattItems().forEach(function (it) { if (U.matt === it.key) list.push(it); });
      legItems().forEach(function (it) { if (U.leg === it.key && it.price) list.push(it); });
      return list;
    }
    function upTotal() { return chosen().reduce(function (a, it) { return a + it.price * it.qty; }, 0); }
    function priceTxt(it) {
      var t = '+$' + (it.price * it.qty).toLocaleString('en-US');
      if (it.qty > 1) t += ' <small>($' + it.price + (it.ps ? '/seat' : '/piece') + ' × ' + it.qty + ')</small>';
      return t;
    }
    function renderUpg() {
      if (!U.on || !upBox) return;
      var items = upItems(), mats = mattItems(), c = upCtx();
      var fills = items.filter(function (i) { return i.kind === 'fill'; });
      var checks = items.filter(function (i) { return i.kind !== 'fill'; });
      if (fills.every(function (i) { return i.key !== U.fill; })) U.fill = '';
      if (mats.every(function (i) { return i.key !== U.matt; })) U.matt = '';
      var legs = legItems();
      if (legs.every(function (i) { return i.key !== U.leg; })) U.leg = legs.length ? legs[0].key : '';
      var h = '';
      if (fills.length) {
        h += '<div class="cf-up__grp"><div class="cf-up__h">Cushion Fill</div>' +
          '<label class="cf-up__row"><input type="radio" name="cf-up-fill-' + root.dataset.section + '" value=""' + (U.fill ? '' : ' checked') + '><span>Standard High-Resiliency Foam</span><em>Included</em></label>' +
          fills.map(function (i) { return '<label class="cf-up__row"><input type="radio" name="cf-up-fill-' + root.dataset.section + '" value="' + esc(i.key) + '"' + (U.fill === i.key ? ' checked' : '') + '><span>' + esc(tc(i.lab)) + '</span><em>' + priceTxt(i) + '</em></label>'; }).join('') + '</div>';
      }
      if (checks.length) {
        h += '<div class="cf-up__grp"><div class="cf-up__h">Upgrades</div>' + checks.map(function (i) {
          var k = i.kind === 'skirt' ? 'skirt' : i.key;
          return '<label class="cf-up__row"><input type="checkbox" data-k="' + esc(k) + '"' + (U.sel[k] ? ' checked' : '') + '><span>' + esc(tc(i.lab)) + '</span><em>' + priceTxt(i) + '</em></label>';
        }).join('') + '</div>';
      }
      if (mats.length) {
        h += '<div class="cf-up__grp"><div class="cf-up__h">Sleeper Mattress (' + esc(tc(c.msize.toLowerCase())) + ')</div>' +
          '<label class="cf-up__row"><input type="radio" name="cf-up-matt-' + root.dataset.section + '" value=""' + (U.matt ? '' : ' checked') + '><span>HiPerform Mattress</span><em>Included</em></label>' +
          mats.map(function (i) { return '<label class="cf-up__row"><input type="radio" name="cf-up-matt-' + root.dataset.section + '" value="' + i.key + '"' + (U.matt === i.key ? ' checked' : '') + '><span>' + esc(tc(i.lab)) + '</span><em>' + priceTxt(i) + '</em></label>'; }).join('') + '</div>';
      }
      if (legs.length) {
        h += '<div class="cf-up__grp"><div class="cf-up__h">Leg / Base Finish <small>(Choose One)</small></div><div class="cf-up__legs">' + legs.map(function (i) {
          var col = FIN_COLOR[i.lab] || FIN_COLOR[String(i.lab).split(' · ').pop()] || '#999';
          return '<label class="cf-up__leg"><input type="radio" name="cf-up-leg-' + root.dataset.section + '" value="' + esc(i.key) + '"' + (U.leg === i.key ? ' checked' : '') + '>' +
            '<i style="background:' + col + '"></i><span>' + esc(tc(i.lab)) + '</span><em>' + (i.price ? '+$' + (i.price * i.qty).toLocaleString('en-US') : 'Included') + '</em></label>';
        }).join('') + '</div></div>';
      }
      h += '<div class="cf-up__grp"><div class="cf-up__h">Special Requests <small>(Optional)</small></div><textarea class="cf-up__note" rows="2" placeholder="e.g. contrast stitch color, two-tone cushions, casters">' + esc(U.note) + '</textarea></div>';
      var tot = upTotal();
      h += '<div class="cf-up__tot"' + (tot ? '' : ' hidden') + '>Upgrades Total: <strong>$' + tot.toLocaleString('en-US') + '</strong> <small>added to your cart as separate lines</small></div>';
      upBox.innerHTML = h;
      upBox.closest('.cf-alc__step').hidden = !c;
      syncUpgProps();
    }
    function syncUpgProps() {
      if (!U.on || !form) return;
      var list = chosen().map(function (i) { return i.lab + (i.qty > 1 ? ' ×' + i.qty : ''); });
      setProp('Upgrades', list.join('; '));
      var lg = legItems().filter(function (i) { return i.key === U.leg; })[0];
      setProp('Leg / base finish', lg ? lg.lab : '');
      setProp('Special requests', U.note.trim());
      var v = st.grade && find(st.grade), tot = upTotal();
      if (v && st.sw) $('.cf-alc__selprice').textContent = money(v.price + tot * 100) + (tot ? ' incl. upgrades' : '');
    }
    var propEls = {};
    function setProp(name, val) {
      var el = propEls[name];
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'properties[' + name + ']'; el.setAttribute('form', root.dataset.form); root.appendChild(el); propEls[name] = el; }
      el.value = val || ''; el.disabled = !val;
    }
    if (U.on && upBox) {
      upBox.addEventListener('change', function (e) {
        var t = e.target;
        if (t.name && t.name.indexOf('cf-up-fill') === 0) U.fill = t.value;
        else if (t.name && t.name.indexOf('cf-up-matt') === 0) U.matt = t.value;
        else if (t.dataset.k) U.sel[t.dataset.k] = t.checked;
        else if (t.name && t.name.indexOf('cf-up-leg') === 0) U.leg = t.value;
        renderUpg();
      });
      upBox.addEventListener('input', function (e) { if (e.target.classList.contains('cf-up__note')) { U.note = e.target.value; syncUpgProps(); } });
      Promise.all([
        fetch(root.dataset.upg).then(function (r) { return r.json(); }),
        fetch('/products/american-leather-upgrades.js').then(function (r) { return r.ok ? r.json() : null; })
      ]).then(function (res) {
        U.data = res[0]; U.ids = {};
        if (res[1]) res[1].variants.forEach(function (v) { U.ids[v.title] = v.id; });
        renderTypes(); renderUpg();
      }).catch(function () {});
    }
    function addUpgrades() {
      function vid(vt) { return U.ids && (U.ids[vt] || U.ids[vt.replace('Cooling Gel mattress', 'Gel mattress')]); }
      var items = chosen().filter(function (i) { return vid(i.vt); });
      if (!items.length) return Promise.resolve();
      var forTxt = (root.dataset.title || '') + (st.sw ? ' – ' + st.sw.n : '');
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map(function (i) { return { id: vid(i.vt), quantity: i.qty, properties: { 'For': forTxt } }; }) }) });
    }
    function block(e) {
      if (st.sw && st.sw.com && !(st.comDesc || '').trim()) {
        e.preventDefault(); e.stopImmediatePropagation();
        var er = $('.cf-alc__error'); er.textContent = 'Please describe the fabric you will send (name, color, source).'; er.hidden = false;
        var ci = $('.cf-alc__comin'); if (ci) ci.focus();
        return;
      }
      if (st.sw) {
        if (!U.on || U.added || !chosen().length) { U.added = false; return; }
        e.preventDefault(); e.stopImmediatePropagation();
        if (e.type !== 'submit') { var sb = e.target.closest('[type="submit"]'); }
        addUpgrades().then(function () {
          U.added = true;
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
        return;
      }
      e.preventDefault(); e.stopImmediatePropagation();
      $('.cf-alc__error').textContent = 'Please choose a fabric or leather before adding to cart.';
      $('.cf-alc__error').hidden = false;
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    document.addEventListener('submit', function (e) { if (e.target === form) block(e); }, true);
    if (form) form.addEventListener('click', function (e) { if (e.target.closest('[type="submit"]') && (!st.sw || (st.sw.com && !(st.comDesc || '').trim()))) block(e); }, true);

    var vid = new URLSearchParams(location.search).get('variant');
    var start = variants.filter(function (v) { return String(v.id) === vid; })[0] || variants[0];
    opts.forEach(function (n, i) { if (i !== gi) st.sel[i] = start.o[i]; });
    st.grade = FIXED || start.o[gi]; st.type = G[st.grade].t;
    applyVariant(); render();

    fetch(root.dataset.data).then(function (r) { return r.json(); }).then(function (d) {
      var rows = Array.isArray(d) ? d : d.rows, infos = Array.isArray(d) ? null : d.info;
      if (infos) rows.forEach(function (r) { if (typeof r[10] === 'number') r[10] = infos[r[10]]; });
      // [type, grade, name, sku, slug, colors, brand, tags, ext, handle, info]
      st.all = rows.map(function (r) {
        return { t: r[0], g: r[1], n: r[2], sku: r[3], k: r[4], c: r[5] || '', b: r[6] || '', tags: r[7] || '', f: (r[7] || '').split(','), x: r[8] || 'jpg', h: r[9] || '', info: r[10] || '' };
      });
      pickDefaultGrade(); applyVariant(); render();
    }).catch(function () { st.all = []; render(); });
  }

  function boot() { document.querySelectorAll('.cf-alc').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
